const baseUrl = "PreNCE";

export const preNceApplicationForm = (rrr) => `${baseUrl}/load-application-form?rrr=${rrr}`;

export const addOrUpdatePreNceBiodata = () => `${baseUrl}/add-or-update-pre-nce-application-bio-data`;

export const addOrUpdatePreNceProgramme = () => `${baseUrl}/add-or-update-pre-nce-application-programme-details`;

export const addOrUpdatePreNceEducation = () => `${baseUrl}/add-or-update-pre-nce-education-history`;

export const addOrUpdatePreNceOlevel = () => `${baseUrl}/add-or-update-pre-nce-application-olevel-details`;